import { createSelector } from '@reduxjs/toolkit'
import _identity from 'lodash/identity'

import { FILE_TYPE_ID_DOCUMENT, FILE_TYPE_LOGO, FILE_TYPE_PROOF_OF_ADDRESS } from '../constants'

const getUserFilesSlice = (state) => state.userFiles
const getUserFiles = (state) => getUserFilesSlice(state).items || []

const pluckFileTypes = (_, { fileTypes }) => fileTypes

export const getUserFilesByFileTypes = createSelector([getUserFiles, pluckFileTypes], (userFiles, allowedFileTypes) =>
    userFiles.filter((file) => allowedFileTypes.includes(file.fileType))
)

export const getIdentityVerificationFiles = (state, { identityVerificationId: givenId }) =>
    getUserFiles(state).filter(
        ({ fileType, identityVerificationId }) =>
            fileType === FILE_TYPE_ID_DOCUMENT && identityVerificationId === givenId
    )

export const getAddressVerificationFiles = (state, { identityVerificationId: givenId }) =>
    getUserFiles(state).filter(
        ({ fileType, identityVerificationId }) =>
            fileType === FILE_TYPE_PROOF_OF_ADDRESS && identityVerificationId === givenId
    )

export const getLogo = (state) => getUserFiles(state).find(({ fileType }) => fileType === FILE_TYPE_LOGO)

export const isFetchingUserFiles = (state) => !!getUserFilesSlice(state).isFetching

export default createSelector([getUserFilesSlice], _identity)
